const selectors = {
  storyCarousel: '[data-story-carousel]',
  storySlide: '[data-story-slide]',
  storySlideContent: '[data-story-content]',
  storySlideImage: '[data-story-slide-image]',
};

const dom = {};

const cacheDom = () => {
  dom.storyCarousel = document.querySelectorAll(selectors.storyCarousel);
};

const activateSlide = (slide, slidesList, slideImagesList) => {
  const windowWidth = document.body.clientWidth;
  const slideIndex = slide.getAttribute('data-story-slide');
  const slideContent = slide.querySelector(selectors.storySlideContent);

  // Hide/show relevant slide images
  slideImagesList.forEach((image) => {
    const imageIndex = image.getAttribute('data-story-slide-image');

    if (slideIndex == imageIndex) {
      image.classList.add('active');
    } else {
      image.classList.remove('active');
    }
  });

  // Hide irrelevant slides
  slidesList.forEach((slide) => {
    slide.classList.remove('active');
    slide.style.height = null;
  });

  slide.classList.add('active');

  if (windowWidth < 752) {
    slide.style.height = `${slideContent.scrollHeight}px`;
  }
};

const handleStoryModalEvents = () => {
  if (dom.storyCarousel) {
    dom.storyCarousel.forEach((storyCarousel) => {
      const thisStoryCarousel = storyCarousel;
      const carouselSlides = thisStoryCarousel.querySelectorAll(
        selectors.storySlide,
      );
      const carouselSlideImages = thisStoryCarousel.querySelectorAll(
        selectors.storySlideImage,
      );

      carouselSlides.forEach((slide) => {
        slide.addEventListener('mouseenter', (event) => {
          const windowWidth = document.body.clientWidth;

          if (windowWidth >= 752) {
            activateSlide(slide, carouselSlides, carouselSlideImages);
          }
        });

        slide.addEventListener('click', (event) => {
          const windowWidth = document.body.clientWidth;

          if (windowWidth < 752) {
            activateSlide(slide, carouselSlides, carouselSlideImages);
          }
        });

        // Activate slides and update them based on the relevant screen size
        window.addEventListener('resize', (event) => {
          const windowWidth = document.body.clientWidth;

          if (slide.classList.contains('active')) {
            if (windowWidth >= 752) {
              const mouseoverEvent = new Event('mouseenter');
              slide.dispatchEvent(mouseoverEvent);
            } else {
              slide.click();
            }
          }
        });

        // Activate the default slide
        if (slide.classList.contains('active')) {
          const windowWidth = document.body.clientWidth;

          if (windowWidth >= 752) {
            const mouseoverEvent = new Event('mouseenter');
            slide.dispatchEvent(mouseoverEvent);
          } else {
            slide.click();
          }
        }
      });
    });
  }
};

const storyBlockModal = {
  init() {
    cacheDom();
    handleStoryModalEvents();
  },
};

export default storyBlockModal;
